import styled from "styled-components"
import { ButtonStyles } from "./ButtonStyles"

export const ButtonButton = styled.button`
    ${ButtonStyles};
`;
